import { BaseAction } from "../../../core/actions/BaseAction";
import { getCmsPopularTrips } from "../../../app/api/getCmsPopularTrips";

/** A footer "Top Routes" entry: just what the link needs to render + fire a search. */
export interface FooterTopRoute {
  /** Backend station id used by search (CMS stop `code`). */
  originCode: string;
  /** Localized origin name for the visible label. */
  originName: string;
  destinationCode: string;
  destinationName: string;
}

/**
 * Lightweight fetch of the CMS popular trips for the footer's Top Routes column.
 * Unlike GetPopularTripsAction this skips the best-prices lookup — the footer
 * only shows route names, so the booking-price call would be wasted work on
 * every page the global footer renders on.
 */
class GetFooterTopRoutesAction extends BaseAction<FooterTopRoute[], void> {
  protected override deduplicate = true;

  override async run(): Promise<FooterTopRoute[]> {
    const routes: FooterTopRoute[] = [];
    try {
      const response = await getCmsPopularTrips();
      if (response.status !== "ok" || !response.answer?.data) {
        return routes;
      }

      for (const trip of response.answer.data) {
        const originCode = trip?.origin?.code;
        const destinationCode = trip?.destination?.code;
        if (!originCode || !destinationCode) continue;

        routes.push({
          originCode,
          originName: trip.origin.name,
          destinationCode,
          destinationName: trip.destination.name,
        });
      }
    } catch (error) {
      console.error("Error fetching footer top routes:", error);
    }
    return routes;
  }
}

export const getFooterTopRoutesAction = new GetFooterTopRoutesAction();
